import { useTranslation } from 'react-i18next';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { SUPPORT_EMAIL, SUPPORT_MAILTO } from '@/lib/contact';

// Refund and cancellation policy. Restates, in one place, the rules the rest
// of the site already promises (pricing rules, Terms §3, the storybook FAQ).
// Copy lives in locales/{en,es}.json under refundsPage.
const SECTIONS = ['credits', 'failed', 'storybook', 'print', 'other', 'how'] as const;

export default function Refunds() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <section className="py-16">
          <div className="container mx-auto px-4 max-w-3xl">
            <h1 className="text-3xl md:text-4xl font-bold mb-6">{t('refundsPage.title')}</h1>
            <p className="text-muted-foreground mb-8">{t('refundsPage.intro')}</p>
            <div className="space-y-8">
              {SECTIONS.map((section) => (
                <section key={section} className="space-y-3">
                  <h2 className="text-xl font-semibold">{t(`refundsPage.sections.${section}Title`)}</h2>
                  <p className="leading-7 text-muted-foreground">{t(`refundsPage.sections.${section}Body`)}</p>
                </section>
              ))}
            </div>
            <p className="mt-10 text-muted-foreground">
              {t('refundsPage.contact')}{' '}
              <a href={SUPPORT_MAILTO} className="underline text-primary break-all">{SUPPORT_EMAIL}</a>
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
